module.exports = __webpack_public_path__ + "static/media/activity.496a6d2b.png";